class CartPageInterceptor {
  constructor() {
    if (CartPageInterceptor.instance) {
      return CartPageInterceptor.instance;
    }

    this.isInitialized = false;
    this.originalFetch = null;
    this.originalXHR = null
    this.originalAjax = null;
    this.originalPost = null;
    this.originalGetJSON = null;

    CartPageInterceptor.instance = this;
  }

  static getInstance() {
    if (!CartPageInterceptor.instance) {
      new CartPageInterceptor();
    }
    return CartPageInterceptor.instance;
  }

  isCartPage() {
    return document.body.classList.contains('template-cart') ||
      window.location.pathname === '/cart' ||
      window.location.pathname.includes('/cart');
  }

  isFromCartService(stack) {
    if (!stack) return false;
    return stack.includes('cart-service.js') ||
      stack.includes('cart-service.bundle.js') ||
      stack.includes('cart-cache.js');
  }


  async init() {
    if (this.isInitialized || !this.isCartPage()) {
      return;
    }

    console.log('[Cart Page Interceptor] Initialized for cart page');

    this.originalFetch = window.fetch;
    this.originalXHR = window.XMLHttpRequest;
    this.originalAjax = window.jQuery ? window.jQuery.ajax : null;
    this.originalPost = window.jQuery ? window.jQuery.post : null;
    this.originalGetJSON = window.jQuery ? window.jQuery.getJSON : null;

    this._setupFetchInterceptor();
    this._setupXMLHttpRequestInterceptor();
    this._setupJQueryInterceptors();

    this.isInitialized = true;
  }

  _setupFetchInterceptor() {
    const self = this;

    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

      const stack = new Error().stack || '';
      if (
        self.isFromCartService(stack) ||
        !self.isCartPage() ||
        !url?.includes('/cart')
      ) {
        return self.originalFetch.apply(this, args);
      }

      if (url.includes('/cart.js') && window.cartService?.read) {
        console.log('[Cart Page Interceptor] Using cartService.read() for', url);
        return window.cartService.read().then(data => {
          return new Response(JSON.stringify(data), {
            status: 200,
            statusText: 'OK',
            headers: { 'Content-Type': 'application/json' }
          });
        });
      }

      if (url.includes('/cart/add.js') && window.cartService?.add) {
        console.log('[Cart Page Interceptor] Using cartService.add() for', url);
        const options = args[1] || {};
        const body = options.body;

        let data;
        if (body instanceof FormData) {
          const id = body.get('id');
          const quantity = parseInt(body.get('quantity') || '1');
          data = { id, quantity };
        } else if (typeof body === 'string') {
          try {
            data = JSON.parse(body);
          } catch (error) {
            const formData = new URLSearchParams(body);
            data = Object.fromEntries(formData);
          }
        } else {
          data = body || {};
        }

        return window.cartService.add({
          data: {
            id: data.id,
            quantity: data.quantity || 1,
            properties: data.properties || {}
          },
        });
      }

      if (url.includes('/cart/change') && window.cartService?.change) {
        console.log('[Cart Page Interceptor] Using cartService.change()');
        const options = args[1] || {};
        const body = options.body;

        let data;
        if (typeof body === 'string') {
          try {
            data = JSON.parse(body);
          } catch (error) {
            const formData = new URLSearchParams(body);
            data = Object.fromEntries(formData);
          }
        } else {
          data = body;
        }

        const changeData = {
          id: data.key || data.variant_id || data.id,
          quantity: data.quantity !== undefined ? parseInt(data.quantity) : undefined,
          properties: data.properties || {}
        };

        return window.cartService.change({
          data: changeData,
          queueKey: data.id || 'CartPageInterceptor',
        });
      }

      if (url.includes('/cart/clear.js') && window.cartService?.clear) {
        console.log('[Cart Page Interceptor] Using cartService.clear()');
        return window.cartService.clear();
      }
    };
  }

  _setupXMLHttpRequestInterceptor() {
    const self = this;
    const OriginalXHR = this.originalXHR;

    window.XMLHttpRequest = function () {
      const xhr = new OriginalXHR();
      const originalOpen = xhr.open;
      const originalSend = xhr.send;

      xhr.open = function (method, url, ...rest) {
        this._method = method;
        this._url = url;
        return originalOpen.apply(this, [method, url, ...rest]);
      };

      xhr.send = function (data) {
        const stack = new Error().stack || '';

        if (self.isFromCartService(stack) || !self.isCartPage()) {
          return originalSend.apply(this, arguments);
        }

        if (this._url && this._url.includes('/cart')) {
          const url = this._url;
          const method = this._method;

          if (url.includes('/cart/add.js') && method === 'POST') {
            if (window.cartService?.add) {
              console.log('[Cart Page Interceptor] Using cartService.add() for XHR:', url);

              let requestData = data;
              if (typeof data === 'string') {
                try {
                  requestData = JSON.parse(data);
                } catch (error) {
                  const formData = new URLSearchParams(data);
                  requestData = Object.fromEntries(formData);
                }
              }

              const originalOnLoad = this.onload;
              const originalOnError = this.onerror;

              window.cartService.add({
                data: {
                  id: requestData.id,
                  quantity: requestData.quantity || 1,
                  properties: requestData.properties || {}
                }
              }).then(result => {
                Object.defineProperty(this, 'status', { value: 200, writable: false });
                Object.defineProperty(this, 'statusText', { value: 'OK', writable: false });
                Object.defineProperty(this, 'responseText', { value: JSON.stringify(result), writable: false });
                Object.defineProperty(this, 'readyState', { value: 4, writable: false });

                if (originalOnLoad) originalOnLoad.call(this);
                if (this.onload) this.onload.call(this);
                this.dispatchEvent(new Event('load'));
              }).catch(error => {
                Object.defineProperty(this, 'status', { value: 500, writable: false });
                Object.defineProperty(this, 'statusText', { value: 'Error', writable: false });
                Object.defineProperty(this, 'readyState', { value: 4, writable: false });

                if (originalOnError) originalOnError.call(this);
                if (this.onerror) this.onerror.call(this);
                this.dispatchEvent(new Event('error'));
              });

              return;
            }
          }

          if (url.includes('/cart.js') && method === 'GET' && window.cartService?.read) {
            console.log('[Cart Page Interceptor] Using cartService.read() for XHR:', url);

            const originalOnLoad = this.onload;

            window.cartService.read().then(data => {
              Object.defineProperty(this, 'status', { value: 200, writable: false });
              Object.defineProperty(this, 'statusText', { value: 'OK', writable: false });
              Object.defineProperty(this, 'responseText', { value: JSON.stringify(data), writable: false });
              Object.defineProperty(this, 'readyState', { value: 4, writable: false });

              if (originalOnLoad) originalOnLoad.call(this);
              if (this.onload) this.onload.call(this);
              this.dispatchEvent(new Event('load'));
            }).catch(error => {
              Object.defineProperty(this, 'status', { value: 500, writable: false });
              Object.defineProperty(this, 'readyState', { value: 4, writable: false });

              if (this.onerror) this.onerror.call(this);
              this.dispatchEvent(new Event('error'));
            });

            return;
          }
        }

        return originalSend.apply(this, arguments);
      };

      return xhr;
    };

    Object.setPrototypeOf(window.XMLHttpRequest, OriginalXHR);
    Object.setPrototypeOf(window.XMLHttpRequest.prototype, OriginalXHR.prototype);
  }

  _setupJQueryInterceptors() {
    const self = this;

    if (window.jQuery && this.originalPost) {
      window.jQuery.post = function (url, data, callback) {
        if (url && url.includes('/cart') && self.isCartPage()) {
          console.log('[Cart Page Interceptor] Intercepted $.post:', url);

          if (url.includes('/cart/change.js') && window.cartService?.change) {
            console.log('[Cart Page Interceptor] Using cartService.change()');
            const changeData = {
              id: data.key || data.variant_id || data.id,
              quantity: data.quantity !== undefined ? parseInt(data.quantity) : undefined,
              properties: data.properties || {}
            };

            const cartChangePromise = window.cartService.change({
              data: changeData,
              queueKey: data.id || 'CartPageInterceptor',
            })

            return cartChangePromise.then(result => {
              if (callback) callback(result);
              return Promise.resolve(result);
            });
          }
        }
        return self.originalPost.apply(this, arguments);
      };
    }

    if (window.jQuery && this.originalAjax) {
      window.jQuery.ajax = function (options) {
        const url = typeof options === 'string' ? options : (options.url || '');

        if (url && url.includes('/cart') && self.isCartPage()) {
          console.log('[Cart Page Interceptor] Intercepted $.ajax:', url);

          if (url.includes('/cart/change.js') && window.cartService?.change) {
            console.log('[Cart Page Interceptor] Using cartService.change()');
            const data = options.data || {};
            const changeData = {
              id: data.key || data.variant_id || data.id,
              quantity: data.quantity !== undefined ? parseInt(data.quantity) : undefined,
              properties: data.properties || {}
            };

            const cartChangePromise = window.cartService.change({
              data: changeData,
              queueKey: data.id || 'CartPageInterceptor',
            })

            return cartChangePromise.then(result => {
              if (options.success) options.success(result);
              return Promise.resolve(result);
            }).catch(error => {
              if (options.error) options.error(error);
              throw error;
            });
          }
        }
        return self.originalAjax.apply(this, arguments);
      };
    }

    if (window.jQuery && this.originalGetJSON) {
      // https://api.jquery.com/jQuery.getJSON/
      window.jQuery.getJSON = function (url, dataOrCallback, callbackParam) {
        let data, onSuccess
        if (typeof dataOrCallback === 'function') {
          onSuccess = dataOrCallback;
          data = undefined;
        } else {
          data = dataOrCallback;
          onSuccess = callbackParam;
        }

        if (url && url.includes('/cart') && self.isCartPage()) {
          console.log('[Cart Page Interceptor] Intercepted $.getJSON:', url);

          if (url.includes('/cart.js') && window.cartService?.read) {
            console.log('[Cart Page Interceptor] Using cartService.read() for getJSON');

            return window.cartService.read().then(result => {
              if (onSuccess) {
                onSuccess(result);
              }
              return Promise.resolve(result);
            }).catch(error => {
              console.error('[Cart Page Interceptor] Error in cartService.read():', error);
              throw error;
            });
          }

          if (url.includes('/cart/add.json') && window.cartService?.add) {
            console.log('[Cart Page Interceptor] Using cartService.add() for getJSON');

            const addData = data || {};
            const urlObj = new URL(url, window.location.origin);
            const id = addData.id || urlObj.searchParams.get('id');
            const quantity = parseInt(addData.quantity || urlObj.searchParams.get('quantity') || '1');

            return window.cartService.add({
              data: {
                id: id,
                quantity: quantity,
                properties: addData.properties || {}
              }
            }).then(result => {
              if (onSuccess) onSuccess(result);
              return Promise.resolve(result);
            }).catch(error => {
              console.error('[Cart Page Interceptor] Error in cartService.add():', error);
              throw error;
            });
          }
        }

        return self.originalGetJSON.apply(this, arguments);
      };
    }
  }
}